import { clientApi } from 'shared/api/clientApi'
import { Pagination, Response } from 'shared/models/general'

import { MyOrderExcursion, MyOrders } from '../list/model'

interface PaginationMyExcurtions extends Pagination {
  is_active?: boolean
}

interface ResponseMyOrders extends Pagination, Response<MyOrders[]> {}

export const ExcursionsMyOrder = {
  getMyOrdersExcursions(data: PaginationMyExcurtions) {
    return clientApi.get<ResponseMyOrders>('/excursions/my-orders', {
      params: data,
    })
  },
  getMyOrderExcursion(id: string) {
    return clientApi.get<Response<MyOrderExcursion>>(
      `/excursions/my-order/${id}`,
    )
  },
}
